import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaVideoVideoModel extends BaseModel {
  variables?: { [key: string]: string } | MetaVideoVideoVariables;
}

export interface MetaVideoVideoVariables {
  Video: string;
}

export class MetaVideoVideoInitVariables implements MetaVideoVideoVariables {
  Video = '';
}

export class MetaVideoVideoInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaVideoVideoInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}